import { useEffect, useState } from 'react'
import { useAuth } from 'auth'

const INTERNAL_DOMAIN = '@ritual.co'

/**
 * `useIsInternalUser` is a custom hook that asynchronously loads the user Profile
 * from the AuthContext and checks if the email is internal (i.e. @ritual.co).
 * `isInternalUser` is `boolean | undefined` so it's accurate only when it's a `boolean`.
 * `isLoading` is an optional flag to determine if the value in `isInternalUser` is ready.
 * @returns `[isInternalUser, isLoading]`
 */
const useIsInternalUser = () => {
  const [isInternalUser, setIsInternalUser] = useState<boolean>()
  const [isLoading, setIsLoading] = useState(true)
  const { loadUserProfile } = useAuth()

  useEffect(() => {
    const fetchEmail = async () => {
      const { username } = await loadUserProfile()
      setIsInternalUser(username?.endsWith(INTERNAL_DOMAIN) || false)
    }
    fetchEmail()
  }, [loadUserProfile])

  useEffect(() => {
    if (isInternalUser) setIsLoading(false)
  }, [isInternalUser])

  return [isInternalUser, isLoading]
}

export default useIsInternalUser
